﻿import { useLocation } from "react-router-dom";
import Select from "react-select";
import { Search } from "lucide-react";

import useSyncedFilter from "@/hooks/general/useSyncedFilter";

import classes from "../header.module.scss";

const HeaderSearch = ({ parameter, setParameter, search, setSearch, options, customStyles }) => {
	const location = useLocation();
	const { updateFilter } = useSyncedFilter();

	const buttonEnter = (e) => {
		if (e.key === "Enter") {
			updateFilter({
				search: search,
				parameter: parameter,
				application: location.pathname,
			});
		}
	};

	const handleSearch = () => {
		updateFilter({
			search: search,
			application: location.pathname,
			parameter: parameter,
		});
	};

	const handleInputChange = (e) => {
		setSearch(e.target.value);
		if (e.target.value === "") {
			updateFilter({
				search: "",
				application: "",
			});
		}
	};

	const hasSelector = options && options.length > 0;

	return (
		<div className={classes.searchWrapper}>
			{hasSelector && (
				<div className={classes.searchSelector}>
					<Select
						options={options}
						styles={customStyles}
						placeholder="Buscar por"
						value={options.find((option) => option.value === parameter)}
						onChange={(selectedOption) => {
							setParameter(selectedOption ? selectedOption.value : "");
						}}
					/>
				</div>
			)}
			<div className={classes.searchInputWrapper}>
				<input
					type="text"
					placeholder="Buscar"
					value={search || ""}
					onKeyDown={(e) => buttonEnter(e)}
					className={hasSelector ? classes.withSelector : ""}
					onChange={handleInputChange}
				/>
				<button className={classes.searchButton} onClick={handleSearch} type="button">
					<Search size={20} strokeWidth={2} />
				</button>
			</div>
		</div>
	);
};

export default HeaderSearch;
